import React from "react";
import { useTheme } from "@mui/styles";
import { Box, Typography, Divider } from "@mui/material";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme) => ({
  container: {
    display: "flex",
    flexDirection: { xs: "column" },

    alignItems: "center",
  },
  boxContainer: {
    display: "flex",
    flexDirection: { xs: "column" },
    mt: { xs: "58px" },
  },
  boxContainer2: {
    display: "flex",
    flexDirection: { xs: "column" },
    mt: { xs: "55px" },
  },
  remote: {
    display: "flex",
    flexDirection: { xs: "column" },
    alignItems: { xs: "center" },
  },
  remoteTitle: {
    fontSize: { xs: "25px" },
    lineHeight: { xs: "36px" },
    fontFamily: theme.typography.montserrat.bold,
    textAlign: { xs: "center" },
    mt: { xs: "25px" },
    color: theme.palette.blue.main,
    maxWidth: { xs: "283px" },
    height: { xs: "36px" },
    ml: { md: "14px" },
  },
  remoteImg: {
    height: "56px",
    width: "56px",
  },
  remoteSubtitle: {
    fontSize: { xs: "24px" },
    lineHeight: { xs: "36px" },
    fontFamily: theme.typography.anaHeim.regular,
    textAlign: { xs: "center" },
    mt: { xs: "12px" },
    color: theme.palette.blue.main,
    width: { xs: "243px" },
  },
  imgAndTitleContainer: {
    display: "flex",
    flexDirection: { xs: "column" },
    alignItems: { xs: "center" },
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
  },
  divider: {
    width: { xs: "281px" },
    border: `0.5px solid ${theme.palette.grey.secondary}`,
    mt: { xs: "94.5px" },
  },
  title: {
    color: theme.palette.red.main,
    fontSize: "14px",
    letterSpacing: "1.4px",
    fontFamily: theme.typography.montserrat.semibold,
    mt: { xs: "77px" },
    textAlign: "center",
  },
  subtitle: {
    color: theme.palette.blue.main,
    fontSize: "32px",
    lineHeight: "36px",
    fontFamily: theme.typography.montserrat.light,
    mt: { xs: "16px" },
    textAlign: "center",
    maxWidth: "225px",
  },
  span: {
    fontWeight: "bold",
  },
});

const CourseModalityCardsMobile = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { pathname } = useLocation();
  const componentName = "CourseModalityCardsMobile";
  const translation = useTranslation(pathname, componentName);
  const { title, subtitle, cards } = translation;

  return (
    <Box sx={classes.container}>
      <Typography sx={classes.title}>{title}</Typography>

      <Typography sx={classes.subtitle}>
        {subtitle[0]}
        <b>{subtitle[1]}</b>
      </Typography>

      <Box sx={classes.boxContainer}>
        <Box sx={classes.remote}>
          <Box sx={classes.imgAndTitleContainer}>
            {cards[0].img && (
              <img
                src={cards[0].img.src}
                alt={cards[0].img.alt}
                style={classes.remoteImg}
              />
            )}

            <Typography sx={classes.remoteTitle}>{cards[0].title}</Typography>
          </Box>
          <Box sx={classes.textContainer}>
            <Typography sx={classes.remoteSubtitle}>
              {cards[0].subtitle[0]}
            </Typography>
            <Typography sx={classes.remoteSubtitle}>
              {cards[0].subtitle[1]}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box sx={classes.boxContainer2}>
        <Box sx={classes.remote}>
          <Box sx={classes.imgAndTitleContainer}>
            {cards[1].img && (
              <img
                src={cards[1].img.src}
                alt={cards[1].img.alt}
                style={classes.remoteImg}
              />
            )}

            <Typography sx={classes.remoteTitle}>{cards[1].title}</Typography>
          </Box>
          <Box sx={classes.textContainer}>
            <Typography sx={classes.remoteSubtitle}>
              {cards[1].subtitle[0]}
            </Typography>
            <Typography sx={classes.remoteSubtitle}>
              {cards[1].subtitle[1]} <br /> {cards[1].subtitle[2]}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box sx={classes.boxContainer2}>
        <Box sx={classes.remote}>
          <Box sx={classes.imgAndTitleContainer}>
            {cards[2].img && (
              <img
                src={cards[2].img.src}
                alt={cards[2].img.alt}
                style={classes.remoteImg}
              />
            )}

            <Typography sx={classes.remoteTitle}>{cards[2].title}</Typography>
            <Typography sx={classes.remoteSubtitle}>
              {cards[2].subtitle[0]}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Divider sx={classes.divider} />
    </Box>
  );
};

export default CourseModalityCardsMobile;
